module.exports = __webpack_public_path__ + "static/media/foto4.f47265c2.png";